import { makeStyles } from 'tss-react/mui';
import { P2GBox, P2GText, SvgInfo } from '@parcel2go/core-ui';

type SupportingLabelProps = {
  text: string | React.ReactNode;
  icon?: React.ReactNode;
};

const useStyles = makeStyles()((theme) => ({
  box: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    '> div': {
      height: '24px'
    }
  },
  text: {
    color: theme.palette.primary.dark
  },
  icon: {
    display: 'block',
    flexShrink: 1,
    '& > svg': {
      height: '24px',
      width: '24px',
      '&>path': {
        fill: theme.palette.primary.dark
      }
    }
  }
}));

export const SupportingLabel: React.FC<SupportingLabelProps> = ({ icon, text }: SupportingLabelProps) => {
  const { classes } = useStyles();
  return (
    <P2GBox classNames={[classes.box]}>
      <div>
        {icon ? (
          icon
        ) : (
          <P2GBox classNames={[classes.icon]}>
            <SvgInfo />
          </P2GBox>
        )}
      </div>
      <P2GText variant="body2" classNames={[classes.text]}>
        {text}
      </P2GText>
    </P2GBox>
  );
};
export default SupportingLabel;
